export default __webpack_public_path__ + "static/media/IPR-1.b1ac9327.jpg";